import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/_home": [5],
		"/aa-offer": [6],
		"/activate-device": [7],
		"/app-choice": [8],
		"/assessment-purchase": [9],
		"/cancel-subscription": [10,[2]],
		"/cancel-subscription/assessment-center": [11,[2]],
		"/cancel-subscription/confirmation": [12,[2]],
		"/cancel-subscription/pause": [13,[2]],
		"/cancel-subscription/pause/manage": [14,[2]],
		"/cancel-subscription/pause/success": [15,[2]],
		"/cancel-subscription/save-offer": [16,[2]],
		"/cancel-subscription/success": [17,[2]],
		"/claimed-offer": [18],
		"/debug/experiment-assign": [19],
		"/desktop-choice": [20],
		"/download-app": [21],
		"/email-preferences": [22],
		"/expired": [23],
		"/forgot-password": [24],
		"/get-started": [25],
		"/inbound-gateway": [26],
		"/inside-pw": [27],
		"/lg-tv": [28],
		"/login": [29],
		"/logout": [30],
		"/parent-section": [31,[3]],
		"/parent-section/assessment-center": [32,[3]],
		"/parent-section/membership": [33,[3]],
		"/parent-section/membership/billing": [34,[3]],
		"/parent-section/membership/payment": [35,[3]],
		"/password-reset-success": [37],
		"/password-reset": [36],
		"/premium": [38],
		"/prospect-register": [39],
		"/purchase-gift": [40],
		"/qr-entry": [41],
		"/reactivation": [42],
		"/redeem": [43],
		"/reset-link-expired": [44],
		"/subscription-consume": [47],
		"/subscription": [45],
		"/subscription/offer/[offer_hash]": [~46],
		"/support-chatbot": [48],
		"/terminate": [49],
		"/upgrade": [50]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,

	reroute: (() => {})
};

export { default as root } from '../root.svelte';